/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 const heroSlider = document.querySelector(".hero_product_section");
 const socialSlider = document.querySelector(".social_slider_section");
 const crossSell = document.querySelector(".crossSell");


 
 document.addEventListener("DOMContentLoaded", function () {
   let announcement = new Splide("#announcment_slider", {
     type: "loop",
     pagination: false,
     arrows: false,
     pauseOnHover: false,
     focus: "center",
     isNavigation: true,
     gap: 20,
     drag: "free",
     fixedWidth: "25%",
     speed: 2500,
     lazyLoad: true,
     breakpoints: {
       480: {
        fixedWidth: "50%",
       },
     }
   });
  
   announcement.mount(window.splide.Extensions);
 });
 
 if (socialSlider) {
   /* SOCIAL SLIDER */
 
   document.addEventListener("DOMContentLoaded", function () {
     let social_slider = new Splide("#social_slider", {
       type: "loop",
       pagination: false,
       arrows: false,
       pauseOnHover: false,
       focus: "center",
       isNavigation: true, 
       gap: 20,
       drag: "free",
       fixedWidth: 350,
       breakpoints: {
         480: {
           fixedWidth: 200,
         }
       }
     });
 
     social_slider.mount(window.splide.Extensions);
   });
 }



 if (heroSlider) {
   document.addEventListener("DOMContentLoaded", function () {
 
     // /* HERO */
     // gsap.from ('#parallax-1', {
     //     duration: 0.8,
     //     delay: 0.8,
     //     opacity: 0,
     //     ease: "ease",
     //     y: 25
     // })
 
     // gsap.from ('#parallax-2', {
     //     duration: 1.5,
     //     delay: 0,
     //     opacity: 0,
     //     ease: "ease",
     //     y: -50
     // })
 
     // gsap.from ('#parallax-3', {
     //     duration: 1.5,
     //     delay: 0,
     //     opacity: 0,
     //     ease: "ease",
     //     x: -50
     // })
 
     // gsap.from ('#parallax-4', {
     //     duration: 1.5,
     //     delay: 0,
     //     opacity: 0,
     //     ease: "ease",
     //     x: 50
     // })
 
     /* SPLIDE SLIDER  */
 
     let hero = new Splide("#hero_slider", {
       type: "loop",
       perPage: 4,
       focus: "center",
       pagination: false,
       isNavigation: true,
       lazyLoad: "nearby",
       gap: 0,
       autoplay: true,
       interval: 7000,
       dragged: true,
       updateOnMove: true,
       speed: 1200,
       waitForTransition: false,
       rewind: false,
       fixedWidth: "25%", 
       pauseOnHover: false,
       breakpoints: {
        769: {
          perPage: 3,
          fixedWidth: "50%",
        },
      }
     });
 
     let bgSlider = new Splide("#bg_slider", {
       type: "fade",
       perPage: 1,
       focus: "center",
       start: 0,
       arrows: false,
       height: "100vh",
       width: "100vw",
     });
 
     let titleSlider = new Splide("#title_slider", {
       type: "loop",
       perPage: 1,
       focus: "center",
       arrows: false,
       width: "100vw",
       breakpoints: {
         769: {
          width: "80vw",
         }
       }
     });
 
     hero.sync(titleSlider);
     hero.sync(bgSlider);
 
     hero.mount();
     bgSlider.mount();
     titleSlider.mount();
 
    //  var scene1 = document.getElementById("scene1");
    //  var parallax = new Parallax(scene1, {});
 
    //  var scene2 = document.getElementById("scene2");
    //  var parallax = new Parallax(scene2, {});
 
    //  var scene3 = document.getElementById("scene3");
    //  var parallax = new Parallax(scene3, {});
 
    //  var active = document.getElementsByClassName("is-active");
    //  var parallax = new Parallax(active, {});
   });
 }
 
 const enableCrosellContainer = document.querySelector(".rc-widget-injection-parent");
 
 if (enableCrosellContainer) { 
   function enableCrosssell() {
     let cross_sell_section = document.querySelector(".Cross_sell_section");
     let productMeta__Text = document.querySelector(".ProductMeta__Text");
     // Hide Cross Sell Section
 
     // Hide section if it's not on a subscription product
     const targetNode = document.querySelector(".rc-widget-injection-parent");
     const config = { attributes: true, childList: true, subtree: true };
 
     // Callback function to execute when mutations are observed
     const callback = function (mutationsList, observer) {
       // Use traditional 'for loops' for IE 11
       for (const mutation of mutationsList) {
         if (mutation.type === "childList") {
           let inputs = document.querySelectorAll(
             ".rc-widget-injection-parent input"
           );
 
          //  // If onetime purchase is selected hide cross_sell_section and productMeta__Text
          //  inputs.forEach((input) => {
          //    if (input.checked && input.value == "onetime") { 
          //      cross_sell_section.style.display = "none";
          //      productMeta__Text.style.display = "none";
          //      document.getElementById("change-to-sub").setAttribute("aria-hidden", "false");
          //      document.getElementById("sub_usp_container").setAttribute("aria-hidden", "true");
     
          //    } else {
          //      cross_sell_section.style.display = "grid";
          //      productMeta__Text.style.display = "block";
          //      document.getElementById("change-to-sub").setAttribute("aria-hidden", "true");
          //      document.getElementById("sub_usp_container").setAttribute("aria-hidden", "false");
               
          //    }
          //  });
         }
       }
     };
 
     // Create an observer instance linked to the callback function
     const observer = new MutationObserver(callback);
     // Start observing the target node for configured mutations 
     observer.observe(targetNode, config);
   }
 
   enableCrosssell(); // crosssell function
 }
 
 const priceChangeContainer = document.querySelector(".product-tilvalg");
 
 if (priceChangeContainer) {
 
   function observePriceChange() {
     let targetNode = document.querySelector(".ProductMeta__Price");
     let config = { attributes: true, childList: true, subtree: true };
 
     const callback = function (mutationsList, observer) {
       // Use traditional 'for loops' for IE 11
       for (const mutation of mutationsList) {
         if (mutation.type === "childList") {
           let totalprice = targetNode.innerHTML;
           totalprice = totalprice.replace("kr", "");
 
           let total = document.querySelector(".custom_subtotal");
           total.innerHTML = totalprice;
           total.dataset.price = totalprice;
 
           /* TILVALG  */
           if (crossSell) {
             let selectedItems = [];
 
             const tilvalg = document.querySelectorAll(".product-tilvalg");
 
             let totalprice = document.querySelector(".custom_subtotal");
 
             // CHANGE TOTAL ON QUANTITY CHANGE ON ORIGINAL PRODUCT;
 
             const currentProduct = document.querySelector(".ProductForm");
             let currentProductQuantity = 1;
 
             let originalPrice = totalprice.dataset.price;
             originalPrice = originalPrice.replace(",", ".");
             originalPrice = parseFloat(originalPrice);
 
             let price = originalPrice;
 
             document
               .querySelector(".ProductForm__QuantitySelector .QuantitySelector")
               .addEventListener("click", function (e) {
                 let action = e.target.dataset.action;
 
                 switch (action) {
                   case "increase-quantity":
                     currentProductQuantity += 1;
 
                     price += originalPrice;
 
                     totalprice.innerHTML = price;
                     totalprice.dataset.price = price;
 
                     break;
                   case "decrease-quantity":
                     if (currentProductQuantity != 1) {
                       currentProductQuantity -= 1;
 
                       price -= originalPrice;
 
                       totalprice.innerHTML = price;
                       totalprice.dataset.price = price;
                     }
 
                     break;
                   default:
                     break;
                 }
               });
 
             tilvalg.forEach((product) => {
               // Listen to each product in list.
               product.addEventListener("click", function () {
                 // Choose element that get the highlight-product class
                 const prod = this.querySelector(".ProductItem__Wrapper");
                 prod.classList.toggle("highlight-product");
 
                 const id = parseInt(this.querySelector(".product_id").dataset.id);
                 const sellingPlanId = parseInt(
                   this.querySelector(".has_selling_plan").dataset.id
                 );
 
                 let productPrice =
                   this.querySelector(".product_price").dataset.price;
                 productPrice = productPrice.replace(",", ".");
                 productPrice = parseFloat(productPrice);
 
                 if (prod.classList.contains("highlight-product")) {
                   const quantity = 1;
 
                   let item = {};
 
                   if (sellingPlanId != " ") {
                     item = {
                       id: id,
                       quantity: quantity,
                       selling_plan: sellingPlanId,
                     };
                   } else {
                     item = {
                       id: id,
                       quantity: quantity,
                     };
                   }
 
                   selectedItems.push(item);
 
                   // GET PRICE
                   price += productPrice;
 
                   totalprice.dataset.price = price;
                   totalprice.innerHTML = price;
                 } else {
                   index = selectedItems.findIndex((element) => element.id === id);
                   selectedItems.splice(index, 1);
 
                   price -= productPrice;
 
                   totalprice.dataset.price = price;
                   totalprice.innerHTML = price;
                 }
               });
             });
 
             // Get the button
 
             jQuery(".ProductForm__AddToCart").click(function () {
               console.log(selectedItems);
 
               let formData = {
                 items: selectedItems,
               };
 
               setTimeout(() => {
                 AddAllItemsToCart(formData);
                 document.documentElement.dispatchEvent(
                   new CustomEvent("cart:refresh", {
                     bubbles: true,
                   })
                 );
 
                 document
                   .querySelectorAll(".product-tilvalg")
                   .forEach((product) => {
                     product
                       .querySelector(".ProductItem__Wrapper")
                       .classList.remove("highlight-product");
                   });
 
                 selectedItems.length = 0;
                 totalprice.dataset.price = currentProductQuantity * originalPrice;
                 totalprice.innerHTML = currentProductQuantity * originalPrice;
               }, 1000);
             });
           }
         }
       }
     };
 
     // Create an observer instance linked to the callback function
     const observer = new MutationObserver(callback);
     // Start observing the target node for configured mutations
     observer.observe(targetNode, config);
   }
 
 
   observePriceChange();
 }
 
 const tilvalgContainer = document.querySelector(".rc-template__button-group");
 
   function AddAllItemsToCart(tilvalg) {
     data = tilvalg;
     jQuery.ajax({
       type: "POST",
       url: "/cart/add.js",
       data: data,
       dataType: "json",
       success: function () {
         document.documentElement.dispatchEvent(
           new CustomEvent("cart:refresh", {
             bubbles: true,
           })
         );
       },
     });
   }
 
   /* TILVALG END */
 
   /*Accept terms and conditions  */
   $(document).ready(function () {
     $("body").on(
       "click",
       '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
       function () {
         if ($("#agree").is(":checked")) {
           $(this).submit();
         } else {
           alert(
             "Accepter vores handelbetingelser og privatlivspolitik nederst i kurven for at fortsætte"
           );
           return false;
         }
       }
     );
   });
 
   /* add to cart outside of productpage  */
   jQuery(".ad_to_cart_coll").click(function () {
     var ID = jQuery(this).attr("data-var_id");
     addItemToCart(ID, 1); // paste your id product number
     jQuery(".cart_dr").trigger("click");
   });
 
   function addItemToCart(variant_id, qty, selling_plan, original_price, comparePrice) {
     data = {
       id: variant_id,
       quantity: qty,
       selling_plan: selling_plan,
       original_price: original_price,
       comparePrice: comparePrice 
     };
 
     jQuery.ajax({
       type: "POST",
       url: "/cart/add.js",
       data: data,
       dataType: "json",
       success: function () {
         document.documentElement.dispatchEvent(
           new CustomEvent("cart:refresh", {
             bubbles: true,
           })
         );
       },
     });
 
     setTimeout(function () {
       document
         .getElementById("sidebar-cart")
         .setAttribute("aria-hidden", "false");
     }, 1000);
   }
 
   jQuery(".Drawer__Close").click(function () {
     document.getElementById("sidebar-cart").setAttribute("aria-hidden", "true");
   });
 
   /* Recharge cart */
   function swapSubscription(variant_id, qty, selling_plan, original_price) {
     setTimeout(function () {
       data = {
         id: variant_id,
         quantity: qty,
         selling_plan: selling_plan,
         original_price: original_price
       };
       jQuery.ajax({
         type: "POST",
         url: "/cart/add.js",
         data: data,
         dataType: "json",
         success: function () {
           document.documentElement.dispatchEvent(
             new CustomEvent("cart:refresh", {
               bubbles: true,
             })
           );
         },
       });
     }, 1000);
   }
 
   var productId = "7095800660126"; //{ in a template it would be product.id }
   var sectionId = "product-recommendations";
   var limit = "4";
   var url =
     "/recommendations/products?section_id=" +
     sectionId +
     "&limit=" +
     limit +
     "&product_id=" +
     productId;
   var intersectionObserver = new IntersectionObserver(function (entries) {
     // If intersectionRatio is 0, the target is out of view
     // and we do not need to do anything.
     if (entries[0].intersectionRatio <= 0) return;
     fetch(url)
       .then(function (response) {
         //once loaded we can stop observing
         intersectionObserver.unobserve(document.getElementById("product-recs"));
         return response.text();
       })
       .then(function (html) {
         document.getElementById("product-recs").innerHTML = html;
       })
       .catch(function (err) {
         console.warn("Something went wrong.", err);
       });
     console.log("Loaded new items");
   });
   // start observing
   intersectionObserver.observe(document.getElementById("product-recs"));
 


// // DRAG CROSS SELL SECTION 

// document.addEventListener('DOMContentLoaded', function () {
//   const ele = document.getElementById('Cross_sell_section');

//   if (ele) {
//     function grabber () {

//       ele.style.cursor = 'grab';
  
//       let pos = { top: 0, left: 0, x: 0, y: 0 };
  
//       const mouseDownHandler = function (e) {
//           ele.style.cursor = 'grabbing';
//           ele.style.userSelect = 'none';
  
//           pos = {
//               left: ele.scrollLeft,
//               top: ele.scrollTop,
//               // Get the current mouse position
//               x: e.clientX,
//               y: e.clientY,
//           };
  
//           document.addEventListener('mousemove', mouseMoveHandler);
//           document.addEventListener('mouseup', mouseUpHandler);
//       };
  
//       const mouseMoveHandler = function (e) {
//           // How far the mouse has been moved
//           const dx = e.clientX - pos.x;
//           const dy = e.clientY - pos.y;
  
//           // Scroll the element
//           ele.scrollTop = pos.top - dy;
//           ele.scrollLeft = pos.left - dx;
//       };
  
//       const mouseUpHandler = function () {
//           ele.style.cursor = 'grab';
//           ele.style.removeProperty('user-select');
  
//           document.removeEventListener('mousemove', mouseMoveHandler);
//           document.removeEventListener('mouseup', mouseUpHandler);
//       };
  
//       // Attach the handler
//       ele.addEventListener('mousedown', mouseDownHandler);
//     }
  
//   }
//   grabber(); 


// });




gsap.registerPlugin(ScrollTrigger);

//==================================================
// CLOUD SECTION 
//==================================================
let cloudTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".value-icon-section",
    ease: 'Linear',
    start: "top center",
    end: "bottom 180",
    scrub: 1,
    // markers: true 
  }
});

  cloudTl.from ('.value-icon-section', { 
    backgroundColor: '#f7f7f7'
  },'runAtTheSameTime');

  cloudTl.from ('.value_item', {
    opacity: 0,
    stagger: {
      amount: 0.3
    }
  }, 'runAtTheSameTime');

  cloudTl.to ('.top_cloud', {
    left: -900
  }, 'runAtTheSameTime');

  cloudTl.to ('.bottom_cloud', {
    right: -900
  }, 'runAtTheSameTime');

  cloudTl.to ('.value-icon-section', {
    backgroundColor: '#f7f7f7'
  }, 'hide');

  cloudTl.to ('.top_cloud', {
    opacity: 0
  }, 'hide');

  cloudTl.to ('.bottom_cloud', {
    opacity: 0
  }, 'hide');


//==================================================
// INGRIDIENT SECTION 
//==================================================
ScrollTrigger.matchMedia({
  "(min-width: 769px)": () => {
    const ingridientTl = gsap.timeline ( {
      defaults: {}, paused: true
    });

    ingridientTl.from ('.ingridient_item', { 
      opacity: 0,
      id: "orange",
      stagger: {
        grid: [3,3], 
        from: "start",
        amount: 0.5
      }
    })

    const ingridientTlStop = ScrollTrigger.create({
      trigger: ".ingridient_section",
      ease: 'linear',
      id: "orange",
      start: "top center",
      end: "450px center",
      scrub: 1,
      // markers: true,
      onUpdate: ({progress}) => ingridientTl.progress() < progress ? ingridientTl.progress(progress) : null
    });
}});


document.addEventListener("DOMContentLoaded", function () {
  let discount = document.getElementsByClassName('rc_widget__option__discount');
  if (discount) {
    console.log('læst')
    discount.innerHTML = "20%"
  };
}); 